import { createAction } from "@reduxjs/toolkit"

export const resetAppFormState = createAction<void>('resetAppFormState')
